import { t } from '@lingui/core/macro'

export enum PermissoesPasta {
  LEITURA = 'LEITURA',
  LEITURA_ESCRITA = 'LEITURA_ESCRITA'
}

export interface IPermissoesPastaInfo {
  description: string
}

export const PermissoesPastaInfo: Record<
  PermissoesPasta,
  IPermissoesPastaInfo
> = {
  [PermissoesPasta.LEITURA]: {
    description: t`Leitura`
  },
  [PermissoesPasta.LEITURA_ESCRITA]: {
    description: t`Leitura & Escrita`
  }
}
